var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListBulletEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 4.5C3.41053 4.5 4.25 3.66053 4.25 2.625C4.25 1.58947 3.41053 0.75 2.375 0.75C1.33947 0.75 0.5 1.58947 0.5 2.625C0.5 3.66053 1.33947 4.5 2.375 4.5Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 13.25C3.41053 13.25 4.25 12.4105 4.25 11.375C4.25 10.3395 3.41053 9.5 2.375 9.5C1.33947 9.5 0.5 10.3395 0.5 11.375C0.5 12.4105 1.33947 13.25 2.375 13.25Z",
    fill: "#212529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.75H16.75V12H8V10.75ZM8 2H16.75V3.25H8V2Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBulletEditorIcon);
export default __webpack_public_path__ + "static/media/list-bullet-editor-icon.71edb48c91a42b1690d20e87f66463bf.svg";
export { ForwardRef as ReactComponent };